import React from "react";
import ReactDOM from "react-dom/client";
import AppRouter from "./App"; // tu archivo con las rutas (el que mostraste)

// Estilos de Prime (orden recomendado)
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

// Tu CSS global mínimo (si lo tienes)
import "./index.css"; // opcional; si no existe, puedes omitir esta línea

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);
